import React from 'react';
import { Box, Typography } from '@mui/material';
import { GlassmorphicCard } from '../GlassmorphicCard/GlassmorphicCard';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import CloudIcon from '@mui/icons-material/Cloud';
import UmbrellaIcon from '@mui/icons-material/Umbrella';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import './WeatherDisplay.scss';
import clsx from 'clsx';

export type WeatherType = 'sunny' | 'cloudy' | 'rainy' | 'snowy' | 'partlyCloudy';

interface WeatherDisplayProps {
  type: WeatherType;
  temperature?: number;
  location?: string;
  date?: string;
  className?: string;
}

const WeatherIcon = ({ type }: { type: WeatherType }) => {
  switch (type) {
    case 'sunny':
      return <WbSunnyIcon fontSize="large" className="weatherIcon" />;
    case 'cloudy':
      return <CloudIcon fontSize="large" className="weatherIcon" />;
    case 'rainy':
      return <UmbrellaIcon fontSize="large" className="weatherIcon" />;
    case 'snowy':
      return <AcUnitIcon fontSize="large" className="weatherIcon" />;
    case 'partlyCloudy':
      return <FilterDramaIcon fontSize="large" className="weatherIcon" />;
    default:
      return <WbSunnyIcon fontSize="large" className="weatherIcon" />;
  }
};

export const WeatherDisplay: React.FC<WeatherDisplayProps> = ({
  type,
  temperature,
  location,
  date,
  className = '',
}) => {
  const displayType = type || 'sunny';
  const displayTemperature = temperature !== undefined ? `${temperature}°` : '--°';
  const displayLocation = location || 'Fetching...';
  const displayDate = date;

  return (
    <GlassmorphicCard className={clsx('weatherDisplay', className)}>
      <Box className={clsx('weatherContainer', displayType)}>
        <WeatherIcon type={displayType} />

        <Typography variant="h4" component="div" fontWeight="bold">
          {displayTemperature}
        </Typography>

        <Typography variant="body1" fontWeight="medium">
          {displayLocation}
        </Typography>

        {displayDate && (
          <Typography variant="caption">
            {displayDate}
          </Typography>
        )}
      </Box>
    </GlassmorphicCard>
  );
};
